export { default } from "./AvatarGroup.js";
export { default as avatarGroupClasses } from "./avatarGroupClasses.js";
export * from "./avatarGroupClasses.js";